import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Event } from './event.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { AuthServerProvider } from '../../shared/auth/auth-jwt.service';

import { FileUploader } from 'ng2-file-upload';

@Injectable()
export class EventService extends AbstractEntityService {

    protected resourceUrl = 'api/events';
    private resourceSearchUrl = 'api/_search/events';
    private resourceSearchNoAuthUrl = 'api/no-auth/_search/events';
    protected resourceCountUrl = 'api/_search/count/events';

    constructor(protected http: HttpClient,
                private dateUtils: DateUtils,
                private authServerProvider: AuthServerProvider) {
                    super(http);
                }

    create(event: Event): Observable<Event> {
        let copy: Event = Object.assign({}, event);
        copy.begining = this.dateUtils.toDate(event.begining);
        copy.ending = this.dateUtils.toDate(event.ending);
        copy.free = copy.free ? copy.free : false;
        return this.http.post<Event>(this.resourceUrl, copy).map((res: Event) => {
            return res;
        });
    }

    update(event: Event): Observable<Event> {
        let copy: Event = Object.assign({}, event);

        return this.http.put<Event>(this.resourceUrl, copy).map((res: Event) => {
            return res;
        });
    }

    cancel(event: Event, sendNotifications: boolean): Observable<Event> {
        let copy: Event = Object.assign({}, event);

        if (sendNotifications) {
            return this.http.put<Event>(this.resourceUrl + '?params=sendNotifications', copy).map((res: Event) => {
                return res;
            });
        } else {
            return this.http.put<Event>(this.resourceUrl, copy).map((res: Event) => {
                return res;
            });
        }
    }

    find(id: number): Observable<Event> {
        return this.http.get<Event>(`${this.resourceUrl}/${id}`).map((res: Event) => {
            let jsonResponse = res;
            jsonResponse.begining = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.begining);
            jsonResponse.ending = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.ending);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<Event[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Event[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<Event[]>) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<Event[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Event[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Event[]>) => this.convertResponse(res))
            ;
    }

    searchNoAuth(req?: any): Observable<HttpResponse<Event[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Event[]>>(this.resourceSearchNoAuthUrl, options)
            .map((res: HttpResponse<Event[]>) => this.convertResponse(res))
            ;
    }

    getNewUploader(eventId: number): FileUploader {
        return new FileUploader({
            url: this.resourceUrl + '/' + eventId + '/image',
            method : 'PUT',
            authToken : 'Bearer ' + this.authServerProvider.getToken()
        });
    }

    private convertResponse(res: HttpResponse<Event[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].begining = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].begining);
            jsonResponse[i].ending = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].ending);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event.service.ts